// src/config/tenant.ts
// 全局行业上下文配置 — 通过 reactive 实现无 Pinia 的跨组件状态共享
import { reactive, watch } from 'vue'

// 定义支持的行业类型
export type IndustryType = 'apparel' | 'machining';

// 行业元数据映射
export const industryMeta: Record<IndustryType, {
  label: string;
  emoji: string;
  description: string;
  color: string;
  bgColor: string;
}> = {
  apparel: {
    label: '服装制造模式',
    emoji: '👗',
    description: '针织/梭织/牛仔等软性制造',
    color: '#ec4899',
    bgColor: '#fdf2f8'
  },
  machining: {
    label: '机加智造模式',
    emoji: '⚙️',
    description: '管件/阀门/精密零件等硬性制造',
    color: '#3b82f6',
    bgColor: '#eff6ff'
  }
};

// 租户全局状态 (使用 reactive 实现无 Pinia 的状态共享)
export const tenantConfig = reactive({
  currentIndustry: (localStorage.getItem('plm_industry') as IndustryType) || 'apparel',
});

// 监听变化并持久化
watch(() => tenantConfig.currentIndustry, (newVal) => {
  localStorage.setItem('plm_industry', newVal);
});

// 便捷判断函数
export const isApparel = () => tenantConfig.currentIndustry === 'apparel';
export const isMachining = () => tenantConfig.currentIndustry === 'machining';

// 获取当前行业元数据
export const currentIndustryMeta = () => industryMeta[tenantConfig.currentIndustry];
